import { render } from "./DeliveryMethod.vue?vue&type=template&id=7d2ac9dc"
import script from "./DeliveryMethod.vue?vue&type=script&lang=js"
export * from "./DeliveryMethod.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__